import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConstantsService } from './api-constants.service';
import {
  CreateTaxExemptionTypeParams,
  ListTaxExemptionTypeRequestParams,
  TaxExemptionType,
  UpdateTaxExemptionTypeParams
} from '~core/models/tax-exemption-type.models';
import { Observable } from 'rxjs';
import { Pagination } from '~core/models/core.models';

@Injectable()
export class TaxExemptionTypeService {
  private _http = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);

  list(
    params?: ListTaxExemptionTypeRequestParams
  ): Observable<Pagination<TaxExemptionType>> {
    return this._http.get<Pagination<TaxExemptionType>>(
      this._apiConstantsService.taxExemptionTypeUrl,
      {
        params: {
          ...params,
          sort: params?.sort || 'label',
          desc: params?.desc || 'asc'
        } as Record<string, any>
      }
    );
  }

  read(id: string): Observable<TaxExemptionType> {
    return this._http.get<TaxExemptionType>(
      `${this._apiConstantsService.taxExemptionTypeUrl}/${id}`
    );
  }

  create(payload: CreateTaxExemptionTypeParams): Observable<TaxExemptionType> {
    return this._http.post<TaxExemptionType>(
      this._apiConstantsService.taxExemptionTypeUrl,
      payload
    );
  }

  update(
    id: string,
    payload: UpdateTaxExemptionTypeParams
  ): Observable<TaxExemptionType> {
    return this._http.patch<TaxExemptionType>(
      `${this._apiConstantsService.taxExemptionTypeUrl}/${id}`,
      payload
    );
  }

  delete(id: string): Observable<unknown> {
    return this._http.delete(
      `${this._apiConstantsService.taxExemptionTypeUrl}/${id}`
    );
  }
}
